<template>
    <div class="text-center px=5" id="preloader_div">
        <div class="spinner-border text-success" role="status">
            <span class="sr-only">Loading...</span>

        </div>
        <span class="text-gray-600 "> Please Wait... </span>
    </div>


</template>

<script>

export default {
    name: 'LoaderHelper',


    data() {
        return []
    },

    mounted() {

    }
};
</script>